
import AlgoImg from "./CurrencyLogo/algorand-algo-logo.png";
import AvaxImg from "./CurrencyLogo/avalanche-avax-logo.png";
import BnbImg from "./CurrencyLogo/bnb-bnb-logo.png";
import BtcImg from "./CurrencyLogo/bitcoin-btc-logo.png";
import BchImg from "./CurrencyLogo/bitcoin-cash-bch-logo.png";
import AdaImg from "./CurrencyLogo/cardano-ada-logo.png";
import LinkImg from "./CurrencyLogo/chainlink-link-logo.png";
import AtomImg from "./CurrencyLogo/cosmos-atom-logo.png";
import CroImg from "./CurrencyLogo/cronos-cro-logo.png";
import DogeImg from "./CurrencyLogo/dogecoin-doge-logo.png";
import EosImg from "./CurrencyLogo/eos-eos-logo.png";
import EthImg from "./CurrencyLogo/ethereum-eth-logo.png";
import hbarImg from "./CurrencyLogo/hedera-hbar-logo.png";
import LtcImg from "./CurrencyLogo/litecoin-ltc-logo.png";
import XnoImg from "./CurrencyLogo/nano-xno-logo.png";
import NeoImg from "./CurrencyLogo/neo-neo-logo.png";
// import DotImg from "./CurrencyLogo/polkadot-dot-logo.png"; // not found
import ShibImg from "./CurrencyLogo/shiba-inu-shib-logo.png";
import SolImg from "./CurrencyLogo/solana-sol-logo.png";
import XlmImg from "./CurrencyLogo/stellar-xlm-logo.png";
import SuiImg from "./CurrencyLogo/sui-sui-logo.png";
import UsdtImg from "./CurrencyLogo/tether-usdt-logo.png";
import TonImg from "./CurrencyLogo/toncoin-ton-logo.png";
import TrxImg from "./CurrencyLogo/tron-trx-logo.png";
import UniImg from "./CurrencyLogo/uniswap-uni-logo.png";
// import LeoImg from "./CurrencyLogo/leo-leo-logo.png";
import UsdcImg from "./CurrencyLogo/usd-coin-usdc-logo.png";
// import WbtImg from "./CurrencyLogo/whitebit-token-wbt-logo.png"; // not foung
import WavesImg from "./CurrencyLogo/waves-waves-logo.png";
import WbtcImg from "./CurrencyLogo/wrapped-bitcoin-wbtc-logo.png";
import XrpImg from "./CurrencyLogo/xrp-xrp-logo.png";
import { tr } from "date-fns/locale";
import { getAllData, getData } from "../../Utility/API";
import { endPoints } from "../../constant/Environment";

const CurrencyList_Frontend = [
  /*{
    name: "Algorand",
    symbol: "ALGO",
    icon_png: "https://cryptologos.cc/logos/algorand-algo-logo.png",
    icon: AlgoImg,
    value: "algo",
  },*/
  /*{
    name: "Avalanche",
    symbol: "AVAX",
    icon_png: "https://cryptologos.cc/logos/avalanche-avax-logo.png",
    value: "avax",
    icon: AvaxImg,
  },*/
  {
    name: "BNB",
    symbol: "BNB",
    icon_png: "https://cryptologos.cc/logos/bnb-bnb-logo.png",
    value: "bnbbsc",
    icon: BnbImg,
  },
  {
    name: "Bitcoin",
    symbol: "BTC",
    icon_png: "https://cryptologos.cc/logos/bitcoin-btc-logo.png",
    value: "btc",
    icon: BtcImg,
  },
  /*{
    name: "Bitcoin Cash",
    symbol: "BCH",
    icon_png: "https://cryptologos.cc/logos/bitcoin-cash-bch-logo.png",
    value: "bch",
    icon: BchImg,
  },*/
  /*{
    name: "Cardano",
    symbol: "ADA",
    icon_png: "https://cryptologos.cc/logos/cardano-ada-logo.png",
    value: "ada",
    icon: AdaImg,
  },*/
  /*{
    name: "Chainlink",
    symbol: "LINK",
    icon_png: "https://cryptologos.cc/logos/chainlink-link-logo.png",
    value: "link",
    icon: LinkImg,
  },*/
  /*{
    name: "Cosmos",
    symbol: "ATOM",
    icon_png: "https://cryptologos.cc/logos/cosmos-atom-logo.png",
    value: "atom",
    icon: AtomImg,
  },*/
  /*{
    name: "Cronos",
    symbol: "CRO",
    icon_png: "https://cryptologos.cc/logos/cronos-cro-logo.png",
    value: "cro",
    icon: CroImg,
  },*/
  /*{
    name: "Dogecoin",
    symbol: "DOGE",
    icon_png: "https://cryptologos.cc/logos/dogecoin-doge-logo.png",
    icon: DogeImg,
    value: "doge",
  },*/
  /*{
    name: "EOS",
    symbol: "EOS",
    icon_png: "https://cryptologos.cc/logos/eos-eos-logo.png",
    value: "eos",
    icon: EosImg,
  },*/
  {
    name: "Ethereum",
    symbol: "ETH",
    icon_png: "https://cryptologos.cc/logos/ethereum-eth-logo.png",
    icon: EthImg,
    value: "eth",
  },
  /*{
    name: "Hedera",
    symbol: "HBAR",
    icon_png: "https://cryptologos.cc/logos/hedera-hbar-logo.png",
    value: "hbar",
    icon: hbarImg,
  },*/
  {
    name: "Litecoin",
    symbol: "LTC",
    icon_png: "https://cryptologos.cc/logos/litecoin-ltc-logo.png",
    value: "ltc",
    icon: LtcImg,
  },
  /*{
    name: "Nano",
    symbol: "XNO",
    icon_png: "https://cryptologos.cc/logos/nano-xno-logo.png",
    value: "xno",
    icon: XnoImg,
  },*/
  /*{
    name: "Neo",
    symbol: "NEO",
    icon_png: "https://cryptologos.cc/logos/neo-neo-logo.png",
    value: "neo",
    icon: NeoImg,
  },*/
  /*{
    name: "Polkadot",
    symbol: "DOT",
    icon_png: "https://cryptologos.cc/logos/polkadot-dot-logo.png", // not found
    value: "dot",
    icon: "",
  },*/
  /*{
    name: "Shiba Inu",
    symbol: "SHIB",
    icon_png: "https://cryptologos.cc/logos/shiba-inu-shib-logo.png",
    value: "shib",
    icon: ShibImg,
  },*/
  /*{
    name: "Solana",
    symbol: "SOL",
    icon_png: "https://cryptologos.cc/logos/solana-sol-logo.png",
    value: "sol",
    icon: SolImg,
  },*/
  /*{
    name: "Stellar",
    symbol: "XLM",
    icon_png: "https://cryptologos.cc/logos/stellar-xlm-logo.png",
    value: "xlm",
    icon: XlmImg,
  },*/
  /*{
    name: "Sui",
    symbol: "SUI",
    icon_png: "https://cryptologos.cc/logos/sui-sui-logo.png",
    value: "sui",
    icon: SuiImg,
  },*/
  /*{
    name: "Tether",
    symbol: "USDT",
    icon_png: "https://cryptologos.cc/logos/tether-usdt-logo.png",
    value: "usdterc20",
    icon: UsdtImg,
  },*/
  /*{
    name: "Toncoin",
    symbol: "TON",
    icon_png: "https://cryptologos.cc/logos/toncoin-ton-logo.png",
    value: "ton",
    icon: TonImg,
  },*/
  {
    name: "TRON",
    symbol: "TRX",
    icon_png: "https://cryptologos.cc/logos/tron-trx-logo.png",
    value: "trx",
    icon: TrxImg,
  },
  /*{
    name: "Uniswap",
    symbol: "UNI",
    icon_png: "https://cryptologos.cc/logos/uniswap-uni-logo.png",
    value: "uni",
    icon: UniImg,
  },*/
  /*{
    name: "UNUS SED LEO",
    symbol: "LEO",
    icon_png: "https://cryptologos.cc/logos/leo-leo-logo.png", //not found
    value: "leo",
    icon: "", //LeoImg
  },*/
  {
    name: "USD Coin",
    symbol: "USDC",
    icon_png: "https://cryptologos.cc/logos/usd-coin-usdc-logo.png",
    value: "usdcbase",
    icon: UsdcImg,
  },
  /*{
    name: "WhiteBIT Token",
    symbol: "WBT",
    icon_png: "https://cryptologos.cc/logos/whitebit-token-wbt-logo.png", // not foung
    value: "bifierc20",
    icon: "", //WbtImg
  },*/
  /*{
    name: "Waves",
    symbol: "WAVES",
    icon_png: "https://cryptologos.cc/logos/waves-waves-logo.png",
    value: "waves",
    icon: WavesImg,
  },*/
  /*{
    name: "Wrapped Bitcoin",
    symbol: "WBTC",
    icon_png: "https://cryptologos.cc/logos/wrapped-bitcoin-wbtc-logo.png",
    value: "wbtcmatic",
    icon: WbtcImg,
  },*/
  /*{
    name: "XRP",
    symbol: "XRP",
    icon_png: "https://cryptologos.cc/logos/xrp-xrp-logo.png",
    value: "xrp",
    icon: XrpImg,
  },*/
];
 
const fetchCurrencyList = async() => {
  try {
    const url = `${endPoints?.api?.CRYPTO_CURRENCY_LIST}`;
    const response = await getAllData(url);
    if(response?.status === "success" && response?.data){
      return response.data.map(currency => ({
        ...currency,
        icon_png: currency.iconPng,
        icon: currency.iconPng
      }));
    }
    else{
      return CurrencyList_Frontend;
    }
  } catch (error) {
    return CurrencyList_Frontend;
  }
}

export { CurrencyList_Frontend as CurrencyList, fetchCurrencyList };
